import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Typography, Grid, Button, TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem, Checkbox, Tabs, Tab } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import PaddedGrid from '../components/PaddedGrid';
import ReportsList from '../components/ReportsList';
import APIService from '../services/APIService';
import Loading from '../components/Loading';
import RestaurantType from '../constants/RestaurantType';
import AppContext from '../AppContext';
import MenuImporter from '../components/MenuImporter';
import { withTranslation } from 'react-i18next';
import MenuList from '../components/MenuList';
import { municipalities } from '../constants/municipalities';
import { QRCodeCanvas } from 'qrcode.react';
import { Fragment } from 'react';
import FeedbackQuestions from './FeedbackQuestions';

class Restaurant extends Component {
    constructor(props) {
        super(props);

        this.restaurantId = props.match.params.restaurantId;

        this.state = Object.assign(
            {},
            props.location.state,
            {
                redirect: false,
                loading: true,
                menudate_from: moment().format('YYYY-MM-DD'),
                menudate_to: moment().format('YYYY-MM-DD'),
                newreportdate: moment().format('YYYY-MM-DD'),
                menutype: 1,
                openImport: false,
                organisations: [],
                reports: [],
                totalMissedReportCount: 0,
                totalReportCount: 0,
                reportsFilters: {
                    displayCount: 10,
                    displayCountMissed: 10,
                    start_date: null,
                    end_date: null,
                    restaurantId: false,
                    pageNumber: 0,
                    missedPageNumber: 0,
                },
                reports_missed: [],
                menus: [],
                totalMenuCount: 0,
                menuFilters: {
                    displayCount: 10,
                    pageNumber: 0,
                },
                foodServiceCategories: [],
                tabIndex: 0,
            }
        );

        this.createChangeEventHandler = this.createChangeEventHandler.bind(this);
    }

    save() {
        const { restaurant } = this.state;

        APIService.updateRestaurant(restaurant.id, restaurant)
            .then(() => {
                AppContext.toast(this.props.t('Ravintolan tiedot tallennettu onnistuneesti!'));
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    destroy() {
        APIService.destroyRestaurant(this.restaurantId)
            .then(() => {
                this.setState({ redirect: true });
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    addMenus(addedMenus) {
        let menus = this.state.menus;
        addedMenus.forEach(menu => menus.push(menu));
        this.sortMenus(this.state.menus);
        AppContext.toast(this.props.t('Menut lisätty!'));
    }

    addMenu() {
        APIService.storeMenu(this.restaurantId, {
            date_from: this.state.menudate_from,
            date_to: this.state.menudate_to,
            type: this.state.menutype
        }).then((menu) => {
            if (menu) {
                let menus = this.state.menus;
                menus.push(menu);
                this.sortMenus(menus);
                AppContext.toast(this.props.t('Menu lisättiin onnistuneesti!'));
            }
        }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    addReport() {
        APIService.storeReport(this.restaurantId, this.state.newreportdate)
            .then((report) => {
                if (report) {
                    let missedReports = this.state.reports_missed;
                    missedReports.push(report);
                    this.sortReports(this.state.reports, missedReports);

                    AppContext.toast(this.props.t('Raportti lisättiin onnistuneesti!'));
                }
            }).catch((e) => {
                AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e);
            });
    }

    renderMenuAddButtons() {
        const buttons = Object.keys(RestaurantType).reduce((acc, key) => {
            acc[key] = <FormControlLabel key={key} value={key} control={<Radio />} label={this.props.t(RestaurantType[key])} />;
            return acc;
        }, {});

        let displayedButtons = null;
        if (this.state.restaurant.type == 3)
            displayedButtons = [buttons[1], buttons[2]];
        else
            displayedButtons = buttons[this.state.restaurant.type];

        let content = (
            <PaddedGrid>
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        type="date"
                        label={this.props.t('Päivämäärä')}
                        value={this.state.menudate_from}
                        onChange={(event) => this.setState({ menudate_from: event.target.value })}
                    />
                </Grid>

                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        type="date"
                        label={this.props.t('Päätos päivämäärä')}
                        value={this.state.menudate_to}
                        onChange={(event) => this.setState({ menudate_to: event.target.value })}
                    />
                </Grid>

                <Grid item xs={3}>
                    <RadioGroup
                        row={true}
                        value={this.state.menutype}
                        onChange={(event) => this.setState({ menutype: event.target.value })}>
                        {displayedButtons}
                    </RadioGroup>
                </Grid>

                <Grid item xs={2}>
                    <Button variant="raised" color="primary" onClick={() => this.addMenu()}>{this.props.t('Lisää menu')}</Button>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        color="primary"
                        onClick={() => this.setState({ openImport: true })}
                    >+ {this.props.t('Tuo CSV tiedostosta')}</Button>
                </Grid>
            </PaddedGrid>
        );

        return content;
    }

    createChangeEventHandler(field) {
        return (event) => {
            let restaurant = this.state.restaurant;

            let value = event.target.value;
            if (event.target.attributes && event.target.attributes.type.textContent === 'checkbox') {
                value = event.target.checked;
            }

            restaurant[field] = value;

            this.setState({ restaurant });
        };
    }

    componentDidMount() {
        Promise.all([
            APIService.getRestaurant(this.restaurantId),
            APIService.getPaginatedMenus(this.restaurantId, this.state.menuFilters),
            APIService.getReports(this.restaurantId, this.state.reportsFilters),
            AppContext.isAdmin() ? APIService.getOrganisations() : undefined,
            APIService.getFoodServiceCategories()
        ]).then(([restaurant, menuData, reportData, organisations, foodServiceCategories]) => {
            this.allReports = reportData.reports;
            this.sortReports(reportData.reports, reportData.missed_reports);
            let menutype = (restaurant.type == 1 || restaurant.type == 3 ? 1 : 2);
            this.setState({
                restaurant,
                menutype,
                menus: menuData.menus,
                totalMenuCount: menuData.total,
                totalReportCount: reportData.totalAmount,
                totalMissedReportCount: reportData.totalMissedAmount,
                organisations: organisations || [],
                foodServiceCategories,
                tabIndex: AppContext.isOrganisation() ? 1 : 0,
            });
            this.setState({ loading: false });
        }).catch((e) => {
            this.setState({ loading: false });
            AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e);
        });
    }

    renderMenus() {
        if (this.state.menus == 0) {
            return;
        }

        return (
            <Grid item xs={12}>
                <Typography variant="title" style={{ marginBottom: '1rem' }}>
                    {this.props.t('Menut')}
                </Typography>
                <MenuList
                    page={this.state.menuFilters.pageNumber}
                    color="#FF0000"
                    menus={this.state.menus}
                    restaurantId={this.restaurantId}
                    rowsPerPage={this.state.menuFilters.displayCount}
                    totalMenuCount={this.state.totalMenuCount}
                    menusToDisplay={this.state.menuFilters.displayCount}
                    onMenusToDisplayChange={this.onMenusToDisplayChange.bind(this)}
                    changePageNumber={this.changeMenusPageNumber.bind(this)}
                />
            </Grid>
        );
    }

    renderMissedReports() {
        if (this.state.reports_missed.length == 0)
            return;

        return (
            <Grid item xs={12}>
                <Typography variant="title" style={{ marginBottom: '1rem' }}>
                    {this.props.t('Aloittamattomat raportit')}
                </Typography>
                <ReportsList
                    page={this.state.reportsFilters.missedPageNumber}
                    color="#FF0000"
                    reports={this.state.reports_missed}
                    restaurant={this.state.restaurant}
                    rowsPerPage={this.state.reportsFilters.displayCountMissed}
                    totalReportsCount={this.state.totalMissedReportCount}
                    reportsToDisplay={this.state.reportsFilters.displayCountMissed}
                    onReportsToDisplayChange={this.onReportsToDisplayChange.bind(this, true)}
                    changePageNumber={this.changePageNumber.bind(this, true)}
                />
            </Grid>
        );
    }

    sortReports(reports, missedReports) {
        reports.sort((a, b) => (a.date > b.date) ? -1 : 1);
        missedReports.sort((a, b) => (a.date > b.date) ? -1 : 1);

        // Material ui table pagination expects all pages before to have data...
        // When page changed, this adds new empty data to reports to fill out pages before
        const { pageNumber, displayCount, missedPageNumber, displayCountMissed } = this.state.reportsFilters;

        const num = pageNumber * displayCount;
        for (let i = 0; i < num; i++) {
            reports.unshift({});
        }

        const numMissed = missedPageNumber * displayCountMissed;
        for (let i = 0; i < numMissed; i++) {
            missedReports.unshift({});
        }

        this.setState({
            reports: reports,
            reports_missed: missedReports,
        });
    }

    sortMenus(menus) {
        menus.sort((a, b) => (a.date_from > b.date_from) ? -1 : 1);

        // Material ui table pagination expects all pages before to have data...
        // When page changed, this adds new empty data to menus to fill out pages before
        const { pageNumber, displayCount } = this.state.menuFilters;

        const num = pageNumber * displayCount;
        for (let i = 0; i < num; i++) {
            menus.unshift({});
        }

        this.setState({ menus });
    }

    filterReports() {
        this.setState({ loading: true });
        if (AppContext.isAdmin() || AppContext.isOrganisation()) {
            APIService.getReports(this.restaurantId, this.state.reportsFilters).then(res => {
                this.sortReports(res.reports, res.missed_reports);
                this.setState({
                    totalReportCount: res.totalAmount,
                    totalMissedReportCount: res.totalMissedAmount,
                    loading: false
                });
            });
        }
    }

    filterMenus() {
        this.setState({ loading: true });
        if (AppContext.isAdmin() || AppContext.isOrganisation()) {
            APIService.getPaginatedMenus(this.restaurantId, this.state.menuFilters)
                .then(res => {
                    this.sortMenus(res.menus);
                    this.setState({ totalMenuCount: res.total, loading: false });
                });
        }
    }

    onReportsToDisplayChange(missedReports = false, count) {
        const key = missedReports ? 'displayCountMissed' : 'displayCount';

        this.setState(prevState => ({
            reportsFilters: {
                ...prevState.reportsFilters,
                [key]: count
            },
            loading: true,
        }), this.filterReports);
    }

    changePageNumber(missedReports = false, page) {
        const key = missedReports ? 'missedPageNumber' : 'pageNumber';

        this.setState(prevState => ({
            reportsFilters: {
                ...prevState.reportsFilters,
                [key]: page
            },
            loading: true,
        }), this.filterReports);
    }

    onMenusToDisplayChange(count) {
        this.setState(prevState => ({
            menuFilters: {
                ...prevState.menuFilters,
                displayCount: count
            },
            loading: true,
        }), this.filterMenus);
    }

    changeMenusPageNumber(page) {
        this.setState(prevState => ({
            menuFilters: {
                ...prevState.menuFilters,
                pageNumber: page
            },
            loading: true,
        }), this.filterMenus);
    }

    renderFeedbackPageInformation() {
        if (!AppContext.isAdmin() && !AppContext.isOrganisation()) {
            return;
        }

        const feedbackUrl = `https://ravintolapalaute.luke.fi/f/${this.restaurantId}`;

        return (
            <PaddedGrid>
                <Typography variant="title" style={{ marginBottom: '1rem', width: '100%' }}>
                    {this.props.t('Palautesivun tiedot')}
                </Typography>
                <Typography style={{ marginBottom: '0.5', width: '100%' }}>
                    {`${this.props.t('Suomeksi')}: `}
                    <a href={feedbackUrl} target="_blank">{feedbackUrl}</a>
                </Typography>
                <Typography style={{ marginBottom: '1rem', width: '100%' }}>
                    {`${this.props.t('Englanniksi')}: `}
                    <a href={`${feedbackUrl}/?lang=en`} target="_blank">{`${feedbackUrl}/?lang=en`}</a>
                </Typography>
                <div style={{ marginRight: 46 }}>
                    <Typography variant="subheading" style={{ marginBottom: '1rem' }}>
                        {this.props.t('Valkoinen tausta')}
                    </Typography>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div>
                            <Typography style={{ marginBottom: '1rem' }}>
                                {this.props.t('Suomeksi')}
                            </Typography>
                            <QRCodeCanvas
                                onClick={(event) => this.handleQrClick(event)}
                                value={feedbackUrl}
                                size={500}
                                style={{ width: 80, height: 80, cursor: 'pointer' }}
                            />
                        </div>
                        <div>
                            <Typography style={{ marginBottom: '1rem' }}>
                                {this.props.t('Englanniksi')}
                            </Typography>
                            <QRCodeCanvas
                                onClick={(event) => this.handleQrClick(event)}
                                value={`${feedbackUrl}/?lang=en`}
                                size={500}
                                style={{ width: 80, height: 80, cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ marginRight: 22, marginBottom: '2rem' }}>
                    <Typography variant="subheading" style={{ marginBottom: '1rem' }}>
                        {this.props.t('Läpinäkyvä tausta')}
                    </Typography>
                    <div style={{ display: 'flex', gap: 12 }}>
                        <div>
                            <Typography style={{ marginBottom: '1rem' }}>
                                {this.props.t('Suomeksi')}
                            </Typography>
                            <QRCodeCanvas
                                onClick={(event) => this.handleQrClick(event)}
                                value={feedbackUrl}
                                size={500} bgColor='rgba(0,0,0,0)'
                                style={{ width: 80, height: 80, cursor: 'pointer' }}
                            />
                        </div>
                        <div>
                            <Typography style={{ marginBottom: '1rem' }}>
                                {this.props.t('Englanniksi')}
                            </Typography>
                            <QRCodeCanvas
                                onClick={(event) => this.handleQrClick(event)}
                                value={`${feedbackUrl}/?lang=en`}
                                size={500} bgColor='rgba(0,0,0,0)'
                                style={{ width: 80, height: 80, cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
            </PaddedGrid>
        );
    }

    renderFeedbackQuestions() {
        if (!AppContext.isAdmin() && !AppContext.isOrganisation()) {
            return;
        }

        return <FeedbackQuestions restaurantId={this.state.restaurant.id} />;
    }

    handleQrClick(event) {
        var link = document.createElement('a');
        link.download = 'FEEDBACK_QR_CODE.png';
        link.href = event.target.toDataURL()
        link.click();
    }

    render() {
        const { restaurant } = this.state;

        if (this.state.redirect) {
            return <Redirect to="/restaurants" />;
        }

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <PaddedGrid>
                <Button component={Link} to="/restaurants">{this.props.t('Takaisin')}</Button>
                <Grid item xs={12}>
                    <Typography variant="display1">{restaurant.name}</Typography>
                    <Typography variant="subheading">{this.props.t(RestaurantType[restaurant.type])}</Typography>
                </Grid>
                <Tabs
                    value={this.state.tabIndex}
                    onChange={(_event, value) => this.setState({ tabIndex: value })}
                    textColor="#000000"
                    TabIndicatorProps={{ style: { backgroundColor: "#000000" } }} // Custom indicator color
                    style={{ marginBottom: '2rem', marginTop: '2rem', width: '100%', borderBottom: '1px solid lightgray' }}
                >
                    <Tab label={this.props.t('Yleiskatsaus')} style={{ display: AppContext.isAdmin() ? 'block' : 'none' }} />
                    <Tab label={this.props.t('Menut')} />
                    <Tab label={this.props.t('Raportit')} />
                    <Tab label={this.props.t('Palaute')} />
                </Tabs>
                {this.state.tabIndex === 0 && (
                    <Fragment>
                        {AppContext.isAdmin() &&
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <Typography variant="subheading">{this.props.t('Organisaatio')}</Typography>
                                    <Select
                                        fullWidth
                                        onChange={this.createChangeEventHandler('organisation_id')}
                                        label={this.props.t('Organisaatio')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={restaurant.organisation_id}>
                                        <MenuItem key={0} value={null}>{this.props.t('Valitse organisaatio')}</MenuItem>
                                        {this.state.organisations.map((organisation) => {
                                            return <MenuItem key={organisation.id} value={organisation.id}>{organisation.name}</MenuItem>;
                                        })}
                                    </Select>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                    <Typography variant="subheading">{this.props.t('Kunta')}</Typography>
                                    <Select
                                        fullWidth
                                        onChange={this.createChangeEventHandler('municipality')}
                                        InputLabelProps={{ shrink: true }}
                                        value={restaurant.municipality}>
                                        <MenuItem key={0} value={null}>{this.props.t('Valitse kunta')}</MenuItem>
                                        {municipalities.sort().map((municipality) => (
                                            <MenuItem key={municipality.value} value={municipality.label}>{municipality.label}</MenuItem>
                                        ))}
                                    </Select>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                    <Typography variant="subheading">{this.props.t('Ravintolatyyppi')}</Typography>
                                    <Select
                                        fullWidth
                                        onChange={this.createChangeEventHandler('food_service_category_id')}
                                        InputLabelProps={{ shrink: true }}
                                        value={restaurant.food_service_category_id}>
                                        <MenuItem key={0} value={null}>{this.props.t('Valitse ravintolatyyppi')}</MenuItem>
                                        {this.state.foodServiceCategories.map((service) => (
                                            <MenuItem key={service.id} value={service.id}>
                                                {this.props.i18n.language === 'fi' ? service.name : service.name_en}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                    <Typography variant="subheading" style={{ marginBottom: '0.5rem' }}>{this.props.t('Kirjausjakso')}</Typography>
                                    <TextField
                                        fullWidth
                                        input="date"
                                        label={this.props.t('Kirjausjakson alku')}
                                        value={restaurant.reporting_period_start}
                                        onChange={this.createChangeEventHandler('reporting_period_start')}
                                        style={{ marginBottom: '0.5rem' }}
                                    />
                                    <TextField
                                        fullWidth
                                        input="date"
                                        label={this.props.t('Kirjausjakson päätös')}
                                        value={restaurant.reporting_period_end}
                                        onChange={this.createChangeEventHandler('reporting_period_end')}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                    <Typography variant="subheading" style={{ marginBottom: '0.5rem' }}>{this.props.t('Käyttäjä')}</Typography>
                                    <TextField
                                        fullWidth
                                        label={this.props.t('Sähköposti')}
                                        value={restaurant.user.email}
                                        disabled
                                    />

                                    <TextField
                                        fullWidth
                                        type="password"
                                        label={this.props.t('Uusi salasana')}
                                        value={restaurant.password}
                                        onChange={this.createChangeEventHandler('password')}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem', marginTop: '1rem' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={restaurant.export_disabled == true}
                                                    onChange={this.createChangeEventHandler('export_disabled')}
                                                />
                                            }
                                            label={this.props.t('Estä raporttien vienti toimipaikalta')} />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={restaurant.notifications_disabled == true}
                                                    onChange={this.createChangeEventHandler('notifications_disabled')}
                                                />
                                            }
                                            label={this.props.t('Estä ilmoitukset')} />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={restaurant.feedback_consent_disabled == true}
                                                    onChange={this.createChangeEventHandler('feedback_consent_disabled')}
                                                />
                                            }
                                            label={this.props.t('Poista vastauskenttä palautelomakkeesta')} />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={restaurant.draw_consent_disabled == true}
                                                    onChange={this.createChangeEventHandler('draw_consent_disabled')}
                                                />
                                            }
                                            label={this.props.t('Poista arvontakenttä palautelomakkeesta')} />
                                    </div>

                                </Grid>

                                <Grid container spacing={24} style={{ margin: '5px 0' }}>
                                    <Button
                                        variant="raised"
                                        color="primary"
                                        onClick={() => this.save()}
                                        style={{ marginRight: '5px' }}
                                    >
                                        {this.props.t('Tallenna')}
                                    </Button>

                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        onClick={() => AppContext.prompt(() => this.destroy())}
                                    >
                                        {this.props.t('Poista')}
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </Fragment>
                )}
                {this.state.tabIndex === 1 && (
                    <Fragment>
                        {this.renderMenus()}
                        {this.renderMenuAddButtons()}
                        <MenuImporter
                            open={this.state.openImport}
                            restaurantId={this.restaurantId}
                            onReceiveMenus={(menus) => this.addMenus(menus)}
                            onClose={() => this.setState({ openImport: false })}
                        />
                    </Fragment>
                )}
                {this.state.tabIndex === 2 && (
                    <Fragment>
                        {this.renderMissedReports()}
                        <Grid item xs={12}>
                            <Typography variant="title" style={{ marginBottom: '1rem' }}>
                                {this.props.t('Raportit')}
                            </Typography>
                            <ReportsList
                                rowsPerPage={this.state.reportsFilters.displayCount}
                                page={this.state.reportsFilters.pageNumber}
                                reports={this.state.reports}
                                restaurant={restaurant}
                                totalReportsCount={this.state.totalReportCount}
                                reportsToDisplay={this.state.reportsFilters.displayCount}
                                onReportsToDisplayChange={this.onReportsToDisplayChange.bind(this, false)}
                                changePageNumber={this.changePageNumber.bind(this, false)}
                            />
                        </Grid>
                        <PaddedGrid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label={this.props.t('Päivämäärälle')}
                                    value={this.state.newreportdate}
                                    onChange={(event) => this.setState({ newreportdate: event.target.value })}
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <Button variant="raised" color="primary" onClick={() => this.addReport()}>{this.props.t('Lisää raportti päivämäärälle')}</Button>
                            </Grid>
                        </PaddedGrid>
                    </Fragment>
                )}
                {this.state.tabIndex === 3 && (
                    <Fragment>
                        {this.renderFeedbackPageInformation()}
                        {this.renderFeedbackQuestions()}
                    </Fragment>
                )}
            </PaddedGrid>
        );
    }
}

Restaurant.propTypes = {
    location: PropTypes.object.isRequired
};

export default withTranslation()(Restaurant);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Restaurant.js